import React, {type FC} from 'react'
import clsx from 'clsx'
import type {ScreenType} from '../types'
import styles from './SecretLetter.scss'

export type SecretLetterProps = {
  isOpen: boolean
  symbol: string
  size: ScreenType
}

export const SecretLetter: FC<SecretLetterProps> = (props) => {
  const {isOpen, symbol, size} = props

  return (
    <div className={clsx(styles.wrap, styles[`wrap__${size}`])}>
      {isOpen && symbol}
    </div>
  )
}
